<div class="basket-summary-container" *ngIf="price">
  <div class="content">
    <div class="prices">
      <div class="label">{{ 'basket.summary.subtotal' | translate }}</div>
      <div class="price"> {{ price.subTotal }} </div>
      <ng-container *ngIf="price.discount as price">
        <div class="label voucher">{{ 'basket.summary.discount' | translate }}</div>
        <div class="price voucher">{{ price }}</div>
      </ng-container>
      <ng-container *ngIf="price.subTotalWithDiscounts as price">
        <div class="label">{{ 'basket.summary.subTotalWithDiscount' | translate }}</div>
        <div class="price">{{ price }}</div>
      </ng-container>
      <div class="label">{{ 'basket.summary.delivery' | translate }}</div>
      <div class="price">{{ price.delivery }}</div>
      <div class="label">{{ 'basket.summary.vat' | translate }}</div>
      <div class="price"> {{ price.vat }} </div>
      <div class="label total">{{ 'basket.summary.total' | translate }}</div>
      <div class="price total"> {{ price.total }} </div>
    </div>
  </div>
</div>
